"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LocationType", {
  enumerable: true,
  get: function () {
    return _LocationType.default;
  }
});
exports.calculateAzimuthFromGpsReadings = calculateAzimuthFromGpsReadings;
Object.defineProperty(exports, "calculateDestination", {
  enumerable: true,
  get: function () {
    return _calculateDestination.default;
  }
});
Object.defineProperty(exports, "calculateDirection", {
  enumerable: true,
  get: function () {
    return _calculateDirection.default;
  }
});
Object.defineProperty(exports, "calculateDistance", {
  enumerable: true,
  get: function () {
    return _calculateDistance.calculateDistance;
  }
});
exports.calculateInterpolatedPosition = calculateInterpolatedPosition;
exports.computeDistance = computeDistance;
exports.isGps = exports.interpolationHash = exports.indexesOfGpsReadings = exports.getSmoothedGpsReadingsFromSegmentGap = exports.getPreviousGpsReading = exports.getNextGpsReading = exports.config = void 0;
exports.isPointSignificantlyMoved = isPointSignificantlyMoved;
exports.readingCoordinates = readingCoordinates;
exports.sendWindowResizeEvent = void 0;
exports.switchToInterpolated = switchToInterpolated;
exports.updateGpsReadingsWithSegmentSmoothedPoints = exports.updateGPSMeasurements = void 0;
var _MiscUtils = _interopRequireDefault(require("./MiscUtils"));
var _memoize = _interopRequireDefault(require("./memoize"));
var _LocationType = _interopRequireDefault(require("./ReadingsUtil/LocationType"));
var _NoGpsReadingWithIndexError = _interopRequireDefault(require("./ErrorClasses/NoGpsReadingWithIndexError"));
var _calculateDistance = require("./MapProcessing/calculateDistance");
var _calculateDestination = _interopRequireDefault(require("./MapProcessing/calculateDestination"));
var _calculateDirection = _interopRequireDefault(require("./MapProcessing/calculateDirection"));
var config = _interopRequireWildcard(require("./MapProcessing/config"));
exports.config = config;
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
// Number of feet GPS smoothing should move to be considered significant
const GPS_COORDINATE_SIGNIFICANTLY_MOVED_THRESHOLD = 1;

// We want this to be global so that we can cache gps interpolations
const interpolationHash = {};
exports.interpolationHash = interpolationHash;
const memoizedGpsReadingsIndexes = new _memoize.default();
function flattenArgObject(argObject) {
  const response = Object.keys(argObject).map(key => `${key}-${argObject[key]}`);
  return response.join('|');
}
function flattenArg(arg) {
  switch (typeof arg) {
    case 'object':
      return flattenArgObject(arg);
    default:
      return arg;
  }
}
function createHashKeyFromArguments(args) {
  const flattenedArgs = args.map(flattenArg);
  return Array.prototype.join.call(flattenedArgs);
}
function switchToInterpolated(gpsreadings) {
  return [...gpsreadings.map(_ref => {
    let {
      nextDistance,
      prevDistance,
      nextAzimuth,
      prevAzimuth,
      ...reading
    } = _ref;
    return {
      ...reading,
      locationType: _LocationType.default.INTERPOLATED
    };
  })];
}
const isGps = reading => {
  return reading.locationType === _LocationType.default.GPS;
};

// TODO: This doesn't really find the next GPSReading if the startIndex is a GPSReading
exports.isGps = isGps;
const getNextGpsReading = (readings, startIndex) => {
  const {
    length
  } = readings;
  for (let i = startIndex; i < length; i += 1) {
    const gpsReading = readings[i];
    if (isGps(gpsReading)) {
      return {
        i,
        gpsReading
      };
    }
  }
  throw new _NoGpsReadingWithIndexError.default('Could not find the next gps reading');
};
exports.getNextGpsReading = getNextGpsReading;
const getPreviousGpsReading = (gpsReadings, currentIndex) => {
  for (let i = currentIndex - 1; i >= 0; i -= 1) {
    const gpsReading = gpsReadings[i];
    if (isGps(gpsReading)) {
      return {
        i,
        gpsReading
      };
    }
  }
  throw new _NoGpsReadingWithIndexError.default('Could not find the previous gps reading');
};
exports.getPreviousGpsReading = getPreviousGpsReading;
function calculateInterpolatedPosition() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  const [lon, lat, nextDistance, nextAzimuth, readingsIndex, readingsArrLength, options = {}] = args;
  const {
    algorithm = config.GEO_ALGORITHMS.GEOD,
    roundCoords = 8
  } = options;

  // TODO: I think the benefits of caching no longer outway the costs
  const interpolationHashKey = createHashKeyFromArguments(args);
  const interpolationFromHashKey = interpolationHash[interpolationHashKey];
  if (interpolationFromHashKey) {
    return interpolationFromHashKey;
  }
  const interpolatedCoordinates = (0, _calculateDestination.default)([lon, lat], nextDistance * (readingsIndex / readingsArrLength), nextAzimuth, {
    roundCoords,
    algorithm
  });
  interpolationHash[interpolationHashKey] = interpolatedCoordinates;
  return interpolatedCoordinates;
}
function readingCoordinates(readingsIndex, gpsReading, readingsArrLength) {
  let coords = [];
  if (readingsIndex === 0 || !gpsReading.nextDistance) {
    coords = gpsReading.coordinates;
  } else {
    coords = calculateInterpolatedPosition(gpsReading.coordinates[1], gpsReading.coordinates[0], gpsReading.nextDistance, gpsReading.nextAzimuth, readingsIndex, readingsArrLength);
  }
  return coords;
}
function isPointSignificantlyMoved(reading) {
  const {
    distanceMoved,
    is_moved: isMoved
  } = reading;
  const distanceSignificantlyMoved = isMoved && distanceMoved >= GPS_COORDINATE_SIGNIFICANTLY_MOVED_THRESHOLD;
  return distanceSignificantlyMoved;
}
function calculateAzimuthFromGpsReadings(fromReading, toReading) {
  const fromCoords = fromReading.coordinates;
  const toCoords = toReading.coordinates;
  return (0, _calculateDirection.default)(fromCoords, toCoords);
}
const _getMemoizedGpsReadingsIndexes = flattenedGpsReadings => {
  return memoizedGpsReadingsIndexes.get([flattenedGpsReadings]);
};
const _setMemoizedGpsReadingsIndexes = (flattenedGpsReadings, indexes) => {
  memoizedGpsReadingsIndexes.set([flattenedGpsReadings], indexes);
};
const _indexesOfGpsReadingsAll = function (flattenedGpsReadings) {
  let {
    memorize = true
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (memorize) {
    const cachedIndexes = _getMemoizedGpsReadingsIndexes(flattenedGpsReadings);
    if (cachedIndexes) {
      return cachedIndexes;
    }
  }
  const indexes = [];
  for (let i = 0; i < flattenedGpsReadings.length; i += 1) {
    const gpsReading = flattenedGpsReadings[i];
    const {
      locationType
    } = gpsReading;
    if (locationType === _LocationType.default.GPS) {
      indexes.push(i);
    }
  }
  _setMemoizedGpsReadingsIndexes(flattenedGpsReadings, indexes);
  return indexes;
};
const _normalize = value => {
  return _MiscUtils.default.roundToDigitPlace(value, 3);
};
const _getDistance = (gps1, gps2) => {
  return (0, _calculateDistance.calculateDistance)(gps1.coordinates, gps2.coordinates);
};
const _getAzimuth = (gps1, gps2) => {
  return calculateAzimuthFromGpsReadings(gps1, gps2);
};
const _setGpsReadingMeasurements = function (flattenedGpsReadings, gpsIndexes) {
  let createCopy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  gpsIndexes.forEach((indexAfter, i) => {
    if (i === 0) {
      return;
    }
    let nextGpsReading = flattenedGpsReadings[indexAfter];
    if (createCopy) {
      nextGpsReading = {
        ...nextGpsReading
      };
      flattenedGpsReadings[indexAfter] = nextGpsReading;
    }
    const indexBefore = gpsIndexes[i - 1];
    const prevGpsReading = flattenedGpsReadings[indexBefore];
    const distance = _normalize(_getDistance(prevGpsReading, nextGpsReading));
    const nextAzimuth = _normalize(_getAzimuth(prevGpsReading, nextGpsReading));
    const prevAzimuth = _normalize(_getAzimuth(nextGpsReading, prevGpsReading));
    const readingsCount = indexAfter - indexBefore;
    const gap = _normalize(distance / readingsCount);
    nextGpsReading.prevDistance = distance;
    prevGpsReading.nextDistance = distance;
    nextGpsReading.prevGap = gap;
    prevGpsReading.nextGap = gap;
    prevGpsReading.nextAzimuth = nextAzimuth;
    nextGpsReading.prevAzimuth = prevAzimuth;
  });
};
const _setInterpolatedReadingMeasurements = function (readings, gpsIndexes) {
  let isUpdateInterpolatedCoords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let createCopy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  gpsIndexes.forEach((previousIndex, i) => {
    const nextIndex = gpsIndexes[i + 1];
    if (!nextIndex) {
      return;
    }

    // There are no interpolated points between these - nothing to do
    if (previousIndex + 1 === nextIndex) {
      return;
    }
    const arrayLength = nextIndex - previousIndex;
    const previousGpsReading = readings[previousIndex];
    const nextGpsReading = readings[nextIndex];

    // For interpolated readings, we need to get azimuth, calculate gap, and ignore distance (distance is only relevent for GPS readings)
    for (let n = previousIndex + 1; n < nextIndex; n += 1) {
      let thisInterpolatedReading = readings[n];
      if (createCopy) {
        thisInterpolatedReading = {
          ...thisInterpolatedReading
        };
        readings[n] = thisInterpolatedReading;
      }
      thisInterpolatedReading.nextAzimuth = previousGpsReading.nextAzimuth;
      thisInterpolatedReading.prevAzimuth = nextGpsReading.prevAzimuth;
      const gap = _normalize(previousGpsReading.nextDistance / arrayLength);
      thisInterpolatedReading.nextGap = gap;
      thisInterpolatedReading.prevGap = gap;
      if (isUpdateInterpolatedCoords) {
        const {
          coordinates,
          nextDistance,
          nextAzimuth
        } = previousGpsReading;
        const coords = calculateInterpolatedPosition(coordinates[1], coordinates[0], nextDistance, nextAzimuth, n - previousIndex, nextIndex - previousIndex);
        thisInterpolatedReading.coordinates = coords;
      }
    }
  });
};
function findGPSReadingIndex(gpsIndexes, index) {
  return gpsIndexes.findIndex(i => i === index);
}
function getGPSReadingForReading(gpsIndexes, flattenedGpsReadings, index) {
  const positionOfGpsReadingIndex = findGPSReadingIndex(gpsIndexes, index);
  if (positionOfGpsReadingIndex !== -1) {
    return positionOfGpsReadingIndex;
  }
  const {
    i
  } = getPreviousGpsReading(flattenedGpsReadings, index);
  return findGPSReadingIndex(gpsIndexes, i);
}
const indexesOfGpsReadings = function (flattenedGpsReadings, index) {
  let {
    memorize = true
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (index >= flattenedGpsReadings.length) {
    return null;
  }
  const gpsIndexes = _indexesOfGpsReadingsAll(flattenedGpsReadings, {
    memorize
  });
  if (index === undefined) {
    return gpsIndexes;
  }
  const positionOfGpsReadingIndex = getGPSReadingForReading(gpsIndexes, flattenedGpsReadings, index);
  if (positionOfGpsReadingIndex === -1) {
    throw new Error(`Could not find reading with location type=GPS and index=${index}`);
  }
  if (index === 0) {
    return gpsIndexes.slice(positionOfGpsReadingIndex,
    // previous reading
    positionOfGpsReadingIndex + 2 // next reading
    );
  }

  // Will return 3 readings in total
  return gpsIndexes.slice(positionOfGpsReadingIndex - 1,
  // previous reading
  positionOfGpsReadingIndex + 2 // next reading
  );
};

// Note: This mutates data directly - be sure to make a copy beforehand
// Note: "index" is an optional parameter, if index=undefined, then the entire readings set will be updated
// Note: - the arg "index" represents the "current index" - that index and the one after (next gps reading) will be updated
// Note: "createCopy" is an optional parameter, if true then will create a copy of the gps reading before updating...the copy will replace the original reading
exports.indexesOfGpsReadings = indexesOfGpsReadings;
const updateGPSMeasurements = function (flattenedGpsReadings) {
  let {
    index,
    isUpdateInterpolatedCoords = false,
    createCopy = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const gpsIndexes = indexesOfGpsReadings(flattenedGpsReadings, index, {
    memorize: !createCopy
  });
  if (!gpsIndexes) {
    return;
  }

  // The gps reading at the current index and and the *next* gps reading will be updated - note that the previous gps reading will not be updated
  _setGpsReadingMeasurements(flattenedGpsReadings, gpsIndexes, createCopy);
  // All readings between the previous gps readings, and next gps readings will be updated
  _setInterpolatedReadingMeasurements(flattenedGpsReadings, gpsIndexes, isUpdateInterpolatedCoords, createCopy);
};
exports.updateGPSMeasurements = updateGPSMeasurements;
const TARGET_READING = {
  PREVIOUS: -1,
  SAME: 0,
  NEXT: 1
};
function getTargetCoordinates(currentReading, targetReading, target, targetPreChanged) {
  switch (true) {
    case target === TARGET_READING.PREVIOUS && targetPreChanged:
      return currentReading.prev_coordinate_before_move || targetReading.coordinate_before_moved || targetReading.coordinates;
    case target === TARGET_READING.SAME && targetPreChanged:
      return targetReading.coordinate_before_moved || targetReading.coordinates;
    case target === TARGET_READING.NEXT && targetPreChanged:
      return currentReading.next_coordinate_before_move || targetReading.coordinate_before_moved || targetReading.coordinates;
    case !targetPreChanged:
      return targetReading.coordinates;
    default:
      return targetReading.coordinate_before_moved || targetReading.coordinates;
  }
}
function computeDistance(currentIndex, targetIndex, readings,
// Try to pull the pre-moved coordinates first
currentPreChanged, targetPreChanged) {
  let {
    /* previousGpsReading, */nextGpsReadingRecord
  } = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  const currentReading = readings[currentIndex];
  if (currentReading === undefined) {
    return 0;
  }
  const target = currentIndex - targetIndex;

  // let targetGpsReading;
  let actualTargetIndex;
  let targetReadings;
  if (readings[targetIndex]) {
    // targetGpsReading = previousGpsReading;
    actualTargetIndex = targetIndex;
    targetReadings = readings;
  } else if (nextGpsReadingRecord) {
    const targetGpsReading = nextGpsReadingRecord;
    targetReadings = targetGpsReading.readings;
    actualTargetIndex = 0; // the first item
  } else {
    return 0;
  }
  const targetReading = targetReadings[actualTargetIndex];

  // To get pre-moved coords
  const coordsOtherPoint = getTargetCoordinates(currentReading, targetReading, target, targetPreChanged);

  // To get actual/current coords (post-moved)
  let currentCoords;
  if (currentPreChanged) {
    currentCoords = currentReading.coordinate_before_moved;
  } else {
    currentCoords = currentReading.coordinates;
  }
  if (coordsOtherPoint === undefined || currentCoords === undefined) {
    return 0;
  }
  const feetFromOtherPoint = (0, _calculateDistance.calculateDistance)([currentCoords[1], currentCoords[0]], [coordsOtherPoint[1], coordsOtherPoint[0]], {
    reverse: false
  });
  return feetFromOtherPoint;
}
const getSmoothedGpsReadingsFromSegmentGap = (gpsreadings, smoothedGpsReadingsIndices) => {
  // We sort by descending so that we can start at the top
  const smoothedGpsReadingsIndicesSorted = smoothedGpsReadingsIndices.slice() // Make copy so sort does not mutate array
  .sort((a, b) => b - a);

  // Shallow copy
  const newGpsReadings = [...gpsreadings];

  // smoothedGpsReadingsIndicesSorted starts with the greatest number
  smoothedGpsReadingsIndicesSorted.forEach(index => {
    // This shouldn't be possible, but we don't want it to happen anyways
    if (index === 0) {
      return;
    }
    newGpsReadings[index] = {
      ...newGpsReadings[index],
      locationType: _LocationType.default.INTERPOLATED
    };
  });
  smoothedGpsReadingsIndicesSorted.forEach(index => {
    if (index === 0) {
      return;
    }
    const {
      i: previousGpsReadingIndex
    } = getPreviousGpsReading(newGpsReadings, index);
    const {
      gpsReading: nextGpsReading,
      i: nextGpsReadingIndex
    } = getNextGpsReading(newGpsReadings, index);
    updateGPSMeasurements(newGpsReadings, {
      previousGpsReadingIndex,
      isUpdateInterpolatedCoords: true,
      createCopy: true
    });
    if (isGps(nextGpsReading || {})) {
      // A shallow copy so that we can update the gps Meansurements
      const nextGpsReadingCopy = {
        ...nextGpsReading
      };
      newGpsReadings[nextGpsReadingIndex] = nextGpsReadingCopy;
      updateGPSMeasurements(newGpsReadings, {
        index: nextGpsReadingIndex,
        isUpdateInterpolatedCoords: true,
        // We need to create copies of readings as we are not certain when they were updated
        createCopy: true
      });
    }
  });
  return newGpsReadings;
};

// returns an immutable copy of globalData/data with the smoothed points within
exports.getSmoothedGpsReadingsFromSegmentGap = getSmoothedGpsReadingsFromSegmentGap;
const updateGpsReadingsWithSegmentSmoothedPoints = (smoothedPoints, globalData, data) => {
  const datFilesByName = globalData.MasterLST;
  const smoothedPointsByDatFileName = {};
  smoothedPoints.forEach(smoothedPoint => {
    const {
      datFile
    } = smoothedPoint;
    const {
      fileName
    } = datFile;
    if (!smoothedPointsByDatFileName[fileName]) {
      smoothedPointsByDatFileName[fileName] = [];
    }
    smoothedPointsByDatFileName[fileName].push(smoothedPoint);
  });
  const smoothedDataByDatFileName = {};
  Object.keys(smoothedPointsByDatFileName).forEach(datFileName => {
    const originalDatFile = datFilesByName[datFileName];
    const {
      gpsreadings
    } = originalDatFile;
    const smoothedPointsForThisDatFile = smoothedPointsByDatFileName[datFileName];
    const gpsReadingsSmoothedIndices = smoothedPointsForThisDatFile.map(smoothedPoint => smoothedPoint.gpsReadingIndex);
    smoothedDataByDatFileName[datFileName] = getSmoothedGpsReadingsFromSegmentGap(gpsreadings, gpsReadingsSmoothedIndices);
  });
  const newData = data.map(datFile => {
    const {
      fileName
    } = datFile;
    if (!smoothedDataByDatFileName[fileName]) {
      return datFile;
    }
    return {
      ...datFile,
      isEdited: true,
      gpsreadings: smoothedDataByDatFileName[fileName]
    };
  });
  const newMasterLST = {};
  newData.forEach(datFile => {
    const {
      fileName
    } = datFile;
    newMasterLST[fileName] = datFile;
  });
  const newGlobalData = {
    ...globalData,
    MasterLST: newMasterLST
  };
  return {
    newData,
    newGlobalData
  };
};

// Send an event which will cause the map and charts to automatically resize
exports.updateGpsReadingsWithSegmentSmoothedPoints = updateGpsReadingsWithSegmentSmoothedPoints;
const sendWindowResizeEvent = () => {
  try {
    // eslint-disable-next-line no-undef
    window.dispatchEvent(new Event('resize'));
  } catch {
    // eslint-disable-next-line no-console
    console.error('Could not reset window size');
  }
};
exports.sendWindowResizeEvent = sendWindowResizeEvent;